import { render, staticRenderFns } from "./managementRegister.vue?vue&type=template&id=28ab21f5"
import script from "./managementRegister.vue?vue&type=script&lang=js"
export * from "./managementRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ab21f5')) {
      api.createRecord('28ab21f5', component.options)
    } else {
      api.reload('28ab21f5', component.options)
    }
    module.hot.accept("./managementRegister.vue?vue&type=template&id=28ab21f5", function () {
      api.rerender('28ab21f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/manage/managementRegister.vue"
export default component.exports